import { render } from "./OrderRejectedDialog.vue?vue&type=template&id=3bf0d26b&ts=true"
import script from "./OrderRejectedDialog.vue?vue&type=script&lang=ts"
export * from "./OrderRejectedDialog.vue?vue&type=script&lang=ts"

import "./OrderRejectedDialog.vue?vue&type=style&index=0&id=3bf0d26b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__